/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rag_Project_Internal_Only_LabelInputs */



/**
* | output |
* | --- |
* | "Internal sources only (project setting)" |
*
* @param {Rag_Project_Internal_Only_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rag_project_internal_only_label = /** @type {((inputs?: Rag_Project_Internal_Only_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rag_Project_Internal_Only_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur interne Quellen (Projekt-Einstellung)")
	return /** @type {LocalizedString} */ ("Internal sources only (project setting)")
});